import React, { useState } from "react";
import { axios } from "@/lib/axios";
import { useLoadingStore } from "@/stores/loading";
import {useNavigate, useSearchParams} from "react-router-dom";
import * as Common from "@/utils/common";
import ConfirmModal from "@/components/ConfirmModal";
import { useUserStore } from "@/stores/user";
import * as Config from "@/config";
import { useMessageModalStore } from "@/stores/message";
import { MESSAGE_NO_E37 } from "@/config";

export default function PasswordChange() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const setLoading = useLoadingStore((state) => state.setLoading);
  const setMessage = useMessageModalStore((state) => state.setMessage);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const [hide1, setHide1] = useState(true);
  const [hide2, setHide2] = useState(true);

  const onClickEye1 = () => {
    setHide1(!hide1);
  };

  const onClickEye2 = () => {
    setHide2(!hide2);
  };

  const onClickSubmit = () => {
    setLoading(true);
    axios
      .post("/api/v1/customers/changePassword", {
        password: password,
        passwordConfirm: passwordConfirm,
        token: searchParams.get("token"),
      })
      .then((result) => {
        if (Object.keys(result.data.errors).length > 0) {
          setError(Common.getNestedValue(result.data.errors));
        } else {
          navigate("/login");
        }
      })
      .catch((error) => {
        console.log(error);
        setMessage(error.response.data.message ?? Config.MESSAGE_NO_E39);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="login-container">
      <div className="login-item">
        <div className="login-item-header">
          <p>パスワード再設定</p>
        </div>
        <div className="login-item-body login-item-body-login">
          {error !== "" && <div className="error-box">{error}</div>}
          <div className="message">
            新しいパスワードを15~64文字で入力してください<br/>
            ※半角英数字、! # $ % &amp; &apos; * + - . / = ? ^ _ &#123; | &#125; ~ @ を使用できます。
          </div>
          <p className="error mt-0">パスワード変更するとDRM-PFのパスワードも同時に変更されます。</p>
          <div className="password">
            <div>新パスワード</div>
            <div className="uk-inline">
              <input
                id="textPassword"
                className="uk-input uk-form-small password-form"
                type={hide1 ? "password" : "text"}
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                id="buttonEye"
                className={
                  hide1
                    ? "uk-form-icon uk-form-icon-flip fa fa-eye-slash"
                    : "uk-form-icon uk-form-icon-flip fa fa-eye"
                }
                onClick={onClickEye1}
              ></button>
            </div>
          </div>
          <div className="password">
            <div>新パスワード（確認）</div>
            <div className="uk-inline">
              <input
                id="textPassword"
                className="uk-input uk-form-small password-form"
                type={hide2 ? "password" : "text"}
                placeholder="password"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
              />
              <button
                id="buttonEye"
                className={
                  hide2
                    ? "uk-form-icon uk-form-icon-flip fa fa-eye-slash"
                    : "uk-form-icon uk-form-icon-flip fa fa-eye"
                }
                onClick={onClickEye2}
              ></button>
            </div>
          </div>
          <div className="uk-flex uk-flex-center uk-margin-small-top">
            <button
              onClick={onClickSubmit}
              className="uk-button--l uk-button-refer uk-margin-small-left"
            >
              パスワード再設定
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
